<script setup>
import { computed }  from "vue";
import { useScheduleItemStore } from "@/stores/ScheduleItemStore"
// import { storeToRefs } from 'pinia';

const store = useScheduleItemStore()
const props = defineProps({
    dateTimes: Object,
})

// const { filteredItems } = storeToRefs( store )
// const { getAllItems } = storeToRefs( store )


const isRelevantDay = ( day ) => {
    return store.filteredItems.filter( (item) => {
        return item.dayAsSlug === day.dayAsSlug
    }).length > 0
}

const showNext = computed(() => {
    // const now = new Date('2022-08-27 15:15:00');
    const now = new Date()
    console.log( now )

    const keyFirst = Object.keys( props.dateTimes )[0]
    const keyLast = Object.keys( props.dateTimes )[ Object.keys( props.dateTimes).length - 1 ]

    const beginningOfConf = new Date( props.dateTimes[keyFirst].day_starts_at )
    const endOfConf = new Date( props.dateTimes[keyLast].day_ends_at )

    endOfConf.setHours(endOfConf.getHours() - 1);

    console.log( beginningOfConf )
    console.log( endOfConf )

    return now >= beginningOfConf && now < endOfConf
})

const handleNext = () => {
    // const now = new Date('2022-08-24 10:00:00');
    const now = new Date()
    console.log( now )

    const date = ('0' + now.getDate()).slice(-2);
    const month = ('0' + (now.getMonth() + 1)).slice(-2);
    const year = now.getFullYear();
    const hours = ('0' + now.getHours()).slice(-2);
    const minutes = ('0' + now.getMinutes()).slice(-2);
    const seconds = ('0' + now.getSeconds()).slice(-2);
    const time = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`

    let upNextItemID = false

    if ( store.view === 'list' && store.filterActive === false ) {
        // console.log( "We're in the grouped list view, use the generated DOM order of the items")
        const dataTime = `${date}-${month}-${year.toString().substring(2)} ${hours}:${minutes}:${seconds}`
        const DOMscheduleItems = document.querySelectorAll( '.schedule-item' )
        const nextItem = Array.from(DOMscheduleItems).find((el) => {
            return el.dataset.startat >= dataTime
        })
        upNextItemID = nextItem.getAttribute('id');
    } else {
        // We're not in the grouped view, the order of the filteredItems will match our DOM order
        upNextItemID = 'item-preview-' + store.filteredItems.find((el) => {
            return el.item_starts_at >= time
        }).id
    }
    
    if ( upNextItemID ) {

        const firstScheduleItemAfter = document.getElementById(upNextItemID)
        const slesWrapper = document.querySelector('.sles__wrapper')
        if ( firstScheduleItemAfter && slesWrapper ) {
            let nextOffsetTop = firstScheduleItemAfter.getBoundingClientRect().top + slesWrapper.scrollTop;

            const slesHeader = document.querySelector('.sles__header')
            const firstsLocationHeader = document.querySelector('.meta-schedule-item--location')
            const firstDayHeader = document.querySelector( '.sles__day__title' )

            if ( slesHeader ) {
                nextOffsetTop -= slesHeader.clientHeight
            }
            if ( firstDayHeader ) {
                nextOffsetTop -= firstDayHeader.clientHeight
            }
            if ( firstsLocationHeader ) {
                nextOffsetTop -= firstsLocationHeader.clientHeight
            }

            slesWrapper.scrollTo({
                top: nextOffsetTop,
                left: 0,
                behavior: 'smooth'
            })
        }
    }

    // original scrolling, but it doesn't take the header offset into account:
    // const url = location.href
    // location.href = `#item-preview-${upNextItemID}`
    // history.replaceState(null, null, url)
}
</script>
<template>
    <p class="sles__header__days__skip">Jump to</p>
    <ul class="sles__header__days__list">
        <li v-if="showNext" class="sles__header__day sles__header__day--next" data-day="next">
            <a 
                href="#next"
                @click.prevent="handleNext()"
            >
                <span class="sles__header__day__regular">Up next</span>
                <span class="sles__header__day__small">Up next</span>
            </a>
        </li>
        <li v-for="(day, index) in props.dateTimes" :key="index" class="sles__header__day" :class="! isRelevantDay( day ) ? 'disabled' : ''" :data-day="day.dayAsSlug"><a :href="`#${day.dayAsSlug}`"><span class="sles__header__day__regular">{{day.dayAsSlug}}</span><span class="sles__header__day__small">{{day.dayAsDM}}</span></a></li>
    </ul>
</template>